// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csContactCenterAccessV1', ['bmHttpUtils', 'bluemoon.components.session']).service('csContactCenterAccessV1',
        ['$http', 'bmHttpUtils', 'AuthenticatedSessionData',
        function($http, bmHttpUtils, authenticatedSessionData) {
            return {
                clientCenterAccessGetList: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/clients/{clientId}/center-accesses';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{clientId}/g, paramsCopy['clientId']);
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: {}, headers: {} }), suppressErrors);
                    });
                },

                get: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/contacts/{contactId}/center-access';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{contactId}/g, paramsCopy['contactId']);
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: {}, headers: {} }), suppressErrors);
                    });
                },

                put: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/contacts/{contactId}/center-access';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{contactId}/g, paramsCopy['contactId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'PUT', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                getContactByPrimaryEmailWithCenterEnabled: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/contacts/center-access/contact-by-primary-email';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'primaryEmail': paramsCopy['primaryEmail'],
                            'excludeId': paramsCopy['excludeId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                getContactByUserId: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/contacts/center-access/contact-by-user-id';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'userId': paramsCopy['userId'],
                            'excludeId': paramsCopy['excludeId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                getDisplayAsByPrimaryEmailWithCenterEnabled: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v4/companies/{companyId}/contacts/center-access/display-as-by-primary-email';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'primaryEmail': paramsCopy['primaryEmail'],
                            'excludeId': paramsCopy['excludeId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                }

            };
        }]);
}(window.angular));
